import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { loginRequest } from "./AuthConfig.jsx";
import { callMsGraph } from "./Graph.jsx";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { UserLogout } from "./UserLogout.jsx";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
// import appInsights, { instrumentationKey } from "../../appMonitor.js";
import { trackUserLoggedIn } from "../Utilities/Telemetry.jsx";

const UserInfo = (props) => {
  const { setShowPreferencesModal } = props;
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.user.loading);
  const hasPhoto = useSelector((state) => state.user.hasPhoto);

  const name = accounts[0] && accounts[0].name;
  const username = accounts[0] && accounts[0].username;

  function RequestProfileData() {
    const request = {
      ...loginRequest,
      account: accounts[0],
      grant_type: 'authorization_code'
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        dispatch(callMsGraph(response.accessToken, setGraphData));
      })
      .catch(() => {
        instance.acquireTokenPopup(request).then((response) => {
          dispatch(callMsGraph(response.accessToken, setGraphData));
        });
      });
  }

  useEffect(() => {
    if (name) {
      RequestProfileData();
    }

    //eslint-disable-next-line
  }, [name]);

  useEffect(() => {
    if(username) {
      trackUserLoggedIn('Id', {username})
    }
  }, [username])

  return (
    <>
      <span>{name}</span>
      <DropdownButton
        id="dropdown-Nav"
        className="menu-dots pull-right rounded-circle"
        title={
          graphData !== null ? (
            <img
              className="user-profile-pic"
              src={graphData}
              alt="user-profile-pic"
            />
          ) : (
            <span className="userText">
              {name !== undefined
                ? name
                    .split(/\s/)
                    .reduce(
                      (response, word) => (response += word.slice(0, 1)),
                      ""
                    )
                : ""}
            </span>
          )
        }
      >
        <Dropdown.Item
          eventKey="1"
          onClick={() => setShowPreferencesModal(true)}
        >
          User Preferences
        </Dropdown.Item>
        <Dropdown.Item eventKey="2">
          <UserLogout />
        </Dropdown.Item>
      </DropdownButton>
    </>
  );
};

export default UserInfo;
